export enum FdrSubType {
  NoRatingFdrEntity = 'fdr_no-rating',
  ModerateFdrEntity = 'fdr_moderate',
  HighFdrEntity = 'fdr_high',
  ExtremeFdrEntity = 'fdr_extreme',
  CatastrophicFdrEntity = 'fdr_catastrophic',
}
